/* The free 2D mock-up request.

   This file owns the dialog. It claims it while the page is still parsing, so
   the first pass in mp-buy.js steps aside, and nothing in that file has to be
   disturbed to change what the dialog does.

   What it adds over the first pass: as many files as the buyer likes, chosen
   in one go or over several trips to the picker, or dropped on the panel; and
   a build panel at the top filled from the sheet as it actually stands —
   size, companions, quantity, show date and total — so whoever picks the
   enquiry up is looking at what the buyer was looking at rather than a
   product name.

   Shopify will not carry a file larger than 20 MB through the storefront, and
   says so with a bare 413. Rather than put a number in front of a buyer, an
   oversize file is kept in the list, flagged quietly, and named in the
   enquiry so somebody can send an upload link for it. The request still goes. */
(function () {
  "use strict";

  var CEILING = 20 * 1024 * 1024;   /* Shopify's own, not ours. Never shown. */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* Claimed now, while the parser is still in the body, so the first pass
     finds it taken when it boots. */
  var dlg = $("[data-mockup-dialog]");
  if (dlg) dlg.dataset.mpm = "1";

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return "$" + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function size(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(bytes >= 10485760 ? 0 : 1) + " MB";
    return Math.max(1, Math.round(bytes / 1024)) + " KB";
  }
  function shortName(o) {
    var t = ((o && o.textContent) || "").replace(/\s+/g, " ").trim();
    var cut = t.indexOf("·");
    if (cut > 0) t = t.slice(0, cut);
    return t.trim() || ((o && o.dataset && o.dataset.name) || "").trim();
  }

  /* The sheet, read straight off the page. */
  function readBuild(root) {
    var form   = $(".mps-buyform", root);
    var sel    = $("[data-variant-select]", root);
    var qtyIn  = $("[data-qty]", root);
    var dateIn = $("[data-show-date]", root);
    var o      = (sel && sel.options.length) ? sel.options[sel.selectedIndex] : null;

    /* A companion row can hold several answers with a count against each
       one, which is more than a select can say. mp-pick.js keeps the list
       in a hidden field beside it; the select is only read when that field
       is not there. */
    var chosen = [], extra = 0;
    $$("[data-addon]", root).forEach(function (s) {
      var carrier = s.parentNode ? s.parentNode.querySelector("[data-addon-cart]") : null;
      if (carrier) {
        var list = [];
        try { list = JSON.parse(carrier.value || "[]") || []; } catch (e) { list = []; }
        list.forEach(function (it) {
          var q = parseInt(it && it.q, 10) || 0;
          if (!it || !it.id || q < 1) return;
          var nm = String(it.n || "").trim();
          chosen.push(q > 1 ? (nm + " \u00d7 " + q) : nm);
          extra += (parseInt(it.c, 10) || 0) * q;
        });
        return;
      }
      var a = s.options[s.selectedIndex];
      if (a && a.value) {
        chosen.push(((a.dataset.name || "").trim()) || shortName(a));
        extra += parseInt(a.dataset.price, 10) || 0;
      }
    });

    var base = o && o.dataset.cents
      ? (parseInt(o.dataset.cents, 10) || 0)
      : (parseInt(form && form.dataset.basePrice, 10) || 0);
    var n = Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);
    var unit = base + extra;

    return {
      stand:  (form && form.dataset.productName) || "",
      build:  (o && ((o.dataset.label || "").trim() || shortName(o))) || "",
      sku:    (o && o.dataset.sku) || "",
      addons: chosen,
      qty:    n,
      date:   (dateIn && dateIn.value) || "",
      unit:   money(unit),
      total:  money(unit * n)
    };
  }

  function fillBuild(dlg, b) {
    var rows = $("[data-sum-rows]", dlg);
    var sku  = $("[data-sum-sku]", dlg);
    if (sku) sku.textContent = b.sku || "";

    var out = [];
    function row(k, v, cls) {
      out.push('<div class="mpq-row' + (cls ? " " + cls : "") + '"><i>' +
               esc(k) + "</i><span>" + esc(v) + "</span></div>");
    }
    if (b.stand) row("Stand", b.stand);
    if (b.build) row("Build", b.build);
    if (b.addons.length) row("Added with it", b.addons.join(", "));
    if (b.qty > 1) row("Quantity", b.qty);
    if (b.date) row("Show date", b.date);
    row("Total", b.qty > 1 ? (b.unit + " each · " + b.total) : b.total, "tot");
    if (rows) rows.innerHTML = out.join("");

    function put(q, v) { var el = $(q, dlg); if (el) el.value = v; }
    put("[data-sum-build]",  b.build);
    put("[data-sum-skuin]",  b.sku);
    put("[data-sum-addons]", b.addons.join(", ") || "None");
    put("[data-sum-qty]",    String(b.qty));
    put("[data-sum-total]",  b.qty > 1
      ? (b.unit + " each, " + b.total + " for " + b.qty)
      : b.total);
  }

  /* The sheet should show that a mock-up was asked for, the same as before. */
  function markRequested(root, email) {
    var mockIn  = $("[data-mockup]", root);
    var mockLb  = $("[data-mockup-label]", root);
    var mockBtn = $("[data-mockup-open]", root);
    var note    = $("[data-mockup-note]", root);
    if (mockIn) mockIn.value = "1";
    if (mockLb) mockLb.textContent = "Mock-up requested";
    if (mockBtn) mockBtn.classList.add("is-done");
    if (note) note.textContent = "On its way to " + (email || "you") + ". Ask again to change anything.";
  }

  /* Shopify's contact form carries no attachment, so each file goes to the
     shop's own files first — briefly as a cart line, removed the moment the
     URL comes back — and the message carries the links. */
  function uploadViaCart(variantId, file) {
    var fd = new FormData();
    fd.append("id", variantId);
    fd.append("quantity", "1");
    fd.append("properties[_mp_mockup_file]", file, file.name);
    return fetch("/cart/add.js", {
      method: "POST", credentials: "same-origin",
      headers: { Accept: "application/json" }, body: fd
    }).then(function (r) {
      if (!r.ok) throw new Error("upload");
      return r.json();
    }).then(function (data) {
      var item = (data.items && data.items[0]) || data;
      var url  = (item.properties || {})._mp_mockup_file || "";
      var key  = item.key;
      if (!key) return url;
      return fetch("/cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { return url; });
    });
  }


  /* ------------------------------------------------------- delivery -- */
  /* Shopify puts hCaptcha in front of POST /contact. Its script binds by
     looking for form[action*='/contact'] and listening for a submit event on
     the document, so two things have to be true or the post arrives with no
     token and Shopify answers "Missing CAPTCHA token": the panel has to be a
     real form with that action, and the browser has to raise a real submit
     event. A fetch raises none. form.submit() raises none either — that is
     the method, not the event — which is what was wrong here.

     So nothing in this file posts any more. The files are lodged first,
     because that part is ours and it is asynchronous; then the handler stands
     aside and lets the browser submit the form, and Shopify's own script puts
     the token on it on the way out. The sheet is put back as the buyer left
     it when the page returns. */
  var STASH = "mp_mockup_pending";

  function sheetState(root) {
    var sel = $("[data-variant-select]", root);
    var qtyIn = $("[data-qty]", root);
    var dIn = $("[data-show-date]", root);
    return {
      path: window.location.pathname,
      variant: sel ? sel.value : "",
      qty: qtyIn ? qtyIn.value : "",
      date: dIn ? dIn.value : ""
    };
  }

  /* Shopify sends the buyer back here with contact_posted=true, so the
     sheet says the request went rather than looking untouched. */
  function settle() {
    if (window.location.search.indexOf("contact_posted=true") < 0) return;
    var raw = null;
    try { raw = window.sessionStorage.getItem(STASH); } catch (e) {}
    if (!raw) return;
    try { window.sessionStorage.removeItem(STASH); } catch (e) {}
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st || st.path !== window.location.pathname) return;

    var root = $("[data-product-root]") || document;
    var sel = $("[data-variant-select]", root);
    var qtyIn = $("[data-qty]", root);
    var dIn = $("[data-show-date]", root);
    if (sel && st.variant) sel.value = st.variant;
    if (qtyIn && st.qty) qtyIn.value = st.qty;
    if (dIn && st.date) dIn.value = st.date;
    if (sel) sel.dispatchEvent(new Event("change", { bubbles: true }));
    markRequested(root, st.email);

    if (window.history && history.replaceState && window.URLSearchParams) {
      var sp = new URLSearchParams(window.location.search);
      sp.delete("contact_posted");
      sp.delete("form_type");
      var qs = sp.toString();
      history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
    }
  }

  function wire() {
    var root = $("[data-product-root]") || document;
    var dlg  = $("[data-mockup-dialog]", root);
    if (!dlg || dlg.dataset.mpq) return;
    dlg.dataset.mpq = "1";
    dlg.dataset.mpm = "1";

    var mform    = $("[data-mockup-form]", dlg);
    var fileIn   = $("[data-mockup-file]", dlg);
    var drop     = $("[data-mockup-drop]", dlg);
    var listEl   = $("[data-mockup-files]", dlg);
    var bigBox   = $("[data-mockup-big]", dlg);
    var urlIn    = $("[data-mockup-fileurl]", dlg);
    var bigIn    = $("[data-mockup-bigin]", dlg);
    var errBox   = $("[data-mockup-err]", dlg);
    var live     = $("[data-mockup-live]", dlg);
    var done     = $("[data-mockup-done]", dlg);
    var doneLine = $("[data-mockup-doneline]", dlg);
    var foot     = $("[data-mockup-foot]", dlg);
    var send     = $("[data-mockup-send]", dlg);
    var openBtn  = $("[data-mockup-open]", root);
    var dateIn   = $("[data-show-date]", root);
    if (!mform) return;

    /* Everything chosen so far, across however many trips to the picker and
       however many drops. Choosing again adds to the pile rather than
       replacing it, which is what a file input does left alone. */
    var picked = [];

    /* The panel scrolls and the footer is pinned to the bottom of it, so the
       line saying what was wrong was written under the fold, behind the
       button. Pressing Send with an empty name moved the cursor and nothing
       else, which reads as a dead button. It is said here instead, on a strip
       directly above the button, which never scrolls away. */
    var strip = document.createElement("p");
    strip.className = "mpq-status";
    strip.setAttribute("role", "status");
    strip.setAttribute("aria-live", "polite");
    strip.hidden = true;
    if (foot && foot.parentNode) foot.parentNode.insertBefore(strip, foot);

    function say(kind, msg) {
      if (!msg) {
        strip.hidden = true;
        strip.textContent = "";
        strip.removeAttribute("data-kind");
        return;
      }
      strip.textContent = msg;
      strip.setAttribute("data-kind", kind);
      strip.hidden = false;
    }

    function flag(el) {
      if (!el) return;
      el.classList.add("is-bad");
      if (el.scrollIntoView) el.scrollIntoView({ block: "center" });
      try { el.focus(); } catch (e) {}
      el.addEventListener("input", function clear() {
        el.classList.remove("is-bad");
        say("", "");
        el.removeEventListener("input", clear);
      });
    }

    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute("open"); }
    $$("[data-mockup-close]", dlg).forEach(function (b) { b.addEventListener("click", close); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });

    if (openBtn) {
      openBtn.addEventListener("click", function () {
        fillBuild(dlg, readBuild(root));
        var when = $('input[name="contact[Show date]"]', dlg);
        if (when && dateIn) {
          if (dateIn.min) when.min = dateIn.min;
          if (dateIn.value && !when.value) when.value = dateIn.value;
        }
        if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", ""); }
        var first = $('input[name="contact[name]"]', dlg);
        if (first) window.setTimeout(function () { first.focus(); }, 80);
      });
    }

    function render() {
      listEl.innerHTML = "";
      picked.forEach(function (p) {
        var li = document.createElement("li");
        li.className = "mpq-file";
        li.dataset.state = p.big ? "big" : (p.url ? "up" : "new");
        li.innerHTML =
          '<span class="dot" aria-hidden="true"></span>' +
          '<span class="nm"></span>' +
          '<span class="sz">' + size(p.file.size) + "</span>" +
          '<button type="button" class="rm" aria-label="Remove">&times;</button>';
        li.querySelector(".nm").textContent = p.file.name;
        li.querySelector(".rm").addEventListener("click", function () {
          var at = picked.indexOf(p);
          if (at > -1) picked.splice(at, 1);
          render();
        });
        listEl.appendChild(li);
      });

      var big = picked.filter(function (p) { return p.big; });
      if (!bigBox) return;
      if (!big.length) { bigBox.hidden = true; return; }
      bigBox.textContent = (big.length === 1 ? "One file is" : big.length + " files are")
        + " too large to travel with this form. Leave it in the list — we will email you"
        + " an upload link for it, and the request still goes through now.";
      bigBox.hidden = false;
    }

    function take(files) {
      Array.prototype.forEach.call(files || [], function (f) {
        var dupe = picked.some(function (p) {
          return p.file.name === f.name && p.file.size === f.size;
        });
        if (!dupe) picked.push({ file: f, big: f.size > CEILING, url: "" });
      });
      render();
      if (errBox) errBox.hidden = true;
    }

    if (fileIn) {
      fileIn.addEventListener("change", function () {
        take(fileIn.files);
        fileIn.value = "";   /* so a removed file can be chosen again */
      });
    }

    if (drop) {
      ["dragenter", "dragover"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.add("over");
        });
      });
      ["dragleave", "dragend"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        });
      });
      drop.addEventListener("drop", function (e) {
        e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        take(e.dataTransfer && e.dataTransfer.files);
      });
    }

    /* Set once the files are lodged and the hidden fields are written. The
       handler runs twice: the first pass does our asynchronous work and stops
       the event, the second is let through to the browser. */
    var armed = false;

    mform.addEventListener("submit", function (e) {
      if (armed) {
        /* Everything below this line belongs to the browser and to Shopify's
           own captcha script. Stand aside. */
        return;
      }
      e.preventDefault();
      errBox.hidden = true; errBox.textContent = "";

      var nameIn  = $('input[name="contact[name]"]', mform);
      var emailIn = $('input[name="contact[email]"]', mform);
      var revert  = send.textContent;

      function fail(msg, el) {
        say("bad", msg);
        errBox.textContent = msg;
        errBox.hidden = false;
        send.disabled = false;
        send.textContent = revert || "Send my request";
        flag(el);
      }

      if (!nameIn.value.trim()) {
        fail("Tell us your name so we know who we are writing to.", nameIn); return;
      }
      if (!emailIn.value.trim() || emailIn.value.indexOf("@") < 1) {
        fail("We need an email address to send the mock-up to.", emailIn); return;
      }

      /* The build is re-read at this moment, not at the moment it opened. */
      fillBuild(dlg, readBuild(root));

      send.disabled = true;
      say("busy", "Sending your request\u2026");
      var variantId = $("[data-variant-id]", root);
      var queue = picked.filter(function (p) { return !p.big && !p.url; });
      var step = 0;

      function next() {
        if (!variantId || step >= queue.length) return Promise.resolve();
        var p = queue[step];
        send.textContent = queue.length > 1
          ? ("Uploading " + (step + 1) + " of " + queue.length + "…")
          : "Uploading…";
        return uploadViaCart(variantId.value, p.file)
          .then(function (url) { p.url = url || ""; })
          .catch(function () { p.big = true; })
          .then(function () { step += 1; render(); return next(); });
      }

      next().then(function () {
        var urls = picked.filter(function (p) { return p.url; })
                         .map(function (p) { return p.file.name + " — " + p.url; });
        var later = picked.filter(function (p) { return p.big; })
                          .map(function (p) { return p.file.name + " (" + size(p.file.size) + ")"; });
        if (urlIn) urlIn.value = urls.length ? urls.join("\n") : "None attached";
        if (bigIn) bigIn.value = later.length ? ("Send an upload link for: " + later.join(", ")) : "";
        send.textContent = "Sending\u2026";

        try {
          var st = sheetState(root);
          st.email = emailIn.value.trim();
          window.sessionStorage.setItem(STASH, JSON.stringify(st));
        } catch (err) {}

        say("busy", "Finishing your request \u2014 one moment\u2026");

        /* requestSubmit, never submit. submit() is the method and raises no
           event, so Shopify's captcha script never sees it and the post lands
           with no token. requestSubmit() raises the real thing. */

        /* If the buyer closes the challenge instead of answering it, no
           navigation happens and the button would sit disabled for ever. The
           page takes this timer with it when it leaves. */
        window.setTimeout(function () {
          send.disabled = false;
          send.textContent = revert || "Send my request";
          say("", "");
        }, 25000);

        armed = true;
        if (mform.requestSubmit) { mform.requestSubmit(); }
        else { armed = false; fail("That did not send. Email sales@megaprintery.com and we will pick it up from there."); }
      }).catch(function () {
        fail("That did not send. Email sales@megaprintery.com and we will pick it up from there.");
      });
    });
  }

  function boot() { wire(); settle(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", wire);
})();
